import React, { forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import { withStyles, TableRow, TableCell, Radio, IconButton, Collapse } from "@material-ui/core";
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import SaveIcon from '@material-ui/icons/Save';
import LocationForm from '../LocationForm';
import { useState } from 'react';

const useStyles = theme => ({
    cell: {
        textAlign: "center",
        padding: theme.spacing(1),
        maxWidth: 250
    },
    addressCell: {
        width: 150,
    },
    radioCell: {
        width: 70
    },
    radio: {
        padding: 0,
        color: theme.palette.secondary.main
    },
    collapseCell: {
        padding: 0
    },
    collapseContent: {
        position: "relative"
    },
    buttonsBar: {
        position: "absolute",
        top: 10,
        right: 10,
        display: "flex",
        flexDirection: "column"
    }
});


const SavedLocationRow = forwardRef((props, ref) => {
    const { classes, data, onRadioClick, elementIdIdentifier, selectedId, coords,
            expandedId, onExpand, onSaveClick, onDeleteClick, onSearch, dataAfterSearch } = props;
    const expanded = Boolean(expandedId === data.poi_id);
    const [updatedData, setUpdatedData] = useState(data);
    const formRef = useRef();

    const onDeleteClickHandler = () => {
        onDeleteClick(data.poi_id);
    };

    const onSaveClickHandler = () => {
        onSaveClick(updatedData);
    };

    const handleChange = (data) => {
        setUpdatedData(data);
    };

    const handleSearch = (data) => {
        onSearch && onSearch(data);
    };

    const handleExpand = () => {
        if(expanded){
            onExpand(null);
        }
        else {
        onExpand(data.poi_id);
        }
    };

    return (
        <React.Fragment>
            <TableRow ref={ref}>
                <TableCell className={clsx([classes.cell, classes.radioCell])}>
                    <Radio
                        className={classes.radio}
                        checked={selectedId === data[elementIdIdentifier]}
                        onClick={() => onRadioClick(data[elementIdIdentifier])}
                    />
                </TableCell>
                <TableCell className={classes.cell}>
                    {data.nazwa}
                </TableCell>
                <TableCell className={clsx([classes.cell, classes.addressCell])}>
                    {data.adres}
                </TableCell>
                <TableCell className={classes.cell}>
                    {data.typ}
                </TableCell>
                <TableCell className={classes.cell}>
                    <IconButton size="small" onClick={handleExpand}>
                        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={5} className={classes.collapseCell}>
                    <Collapse in={expanded} className={classes.collapseContent}>
                        <LocationForm
                            ref={formRef}
                            data={data}
                            coords={coords}
                            onChange={handleChange}
                            onSearch={handleSearch}
                            dataAfterSearch={dataAfterSearch}
                        />
                        <div className={classes.buttonsBar}>
                            <IconButton
                                disabled={updatedData.nazwa === "" || updatedData.adres === "" || updatedData.typ === "" }
                                onClick={onSaveClickHandler}>
                                <SaveIcon />
                            </IconButton>
                            <IconButton onClick={onDeleteClickHandler}>
                                <DeleteSweepIcon />
                            </IconButton>
                        </div>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
});

SavedLocationRow.displayName = "SavedLocationRow";

SavedLocationRow.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object,
    onRadioClick: PropTypes.func,
    elementIdIdentifier: PropTypes.string,
    selectedId: PropTypes.number,
    coords: PropTypes.object,
    expandedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onExpand: PropTypes.func,
    onSaveClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
    onSearch: PropTypes.func,
    dataAfterSearch: PropTypes.object
};

export default withStyles(useStyles)(SavedLocationRow);
